import { useMobileVersion } from '@/shared/lib/use-mobile-version';
import { nativeApp } from '@/shared/services/native-app';

export interface FileType {
  content: string;
  filename: string;
  contentType: string;
}

export enum DownloadFileType {
  PDF = 'pdf',
  XLSX = 'xlsx',
  XML = 'xml',
  DBF = 'dbf',
  URL = 'url',
  TXT = 'txt',
}

interface DownloadFilePayload {
  rawSource: string;
  type: DownloadFileType;
}

export function downloadNativeFile(rawSource: string, type: DownloadFileType = DownloadFileType.PDF) {
  if (type === DownloadFileType.XLSX && !useMobileVersion(1120)) return nativeApp.downloadFileExcel(rawSource);
  const payload: string | DownloadFilePayload = useMobileVersion(1120)
    ? JSON.stringify({ rawSource, type })
    : rawSource;
  return nativeApp.downloadFile(payload);
}

export function downloadFile(file: FileType) {
  const base64 = file.content;
  downloadNativeFile(base64);
}

export function downloadFileExcel(file: FileType) {
  const base64 = file.content;
  nativeApp.downloadFileExcel(base64);
}

export function base64ToUint8Array(base64: string) {
  const binaryString = window.atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
}

export function openFile(file: FileType) {
  const pdfInBase64 = file.content;
  const pdfAsArray = base64ToUint8Array(pdfInBase64);
  const blob = new Blob([pdfAsArray], { type: file.contentType });
  const url = URL.createObjectURL(blob);
  window.open(url, '_blank');
}
